export const SET_STUDENTS_PAGINATION_TOTAL_RECORDS = "SET_STUDENTS_PAGINATION_TOTAL_RECORDS"
export const SET_STUDENTS_PAGINATION_PAGE_SIZE = "SET_STUDENTS_PAGINATION_PAGE_SIZE"
export const SET_SPRINTS_PAGINATION_TOTAL_RECORDS = "SET_SPRINTS_PAGINATION_TOTAL_RECORDS"
export const SET_SPRINTS_PAGINATION_PAGE_SIZE = "SET_SPRINTS_PAGINATION_PAGE_SIZE"
export const SET_HOMEWORKS_PAGINATION = "SET_HOMEWORKS_PAGINATION"
